import React from 'react';
import { css, Global, useTheme } from '@emotion/react';
import { observer } from 'mobx-react';
import { ImmersiveModal } from 'radiance-ui';
import { MEDIA_QUERIES } from 'radiance-ui/lib/constants';

import { useImmersiveModalStore } from 'jsx/stores/immersiveModalStore';
import { isAgencyRebrand } from 'jsx/utils/isAgencyRebrand';

import Style from './style';

const ImmersiveModals = () => {
  const { immersiveModalStore } = useImmersiveModalStore();
  const theme = useTheme();

  if (!immersiveModalStore.showModal) {
    return null;
  }

  // The reskin only applies once the Agency rebrand theme is active, so a
  // flag-off Agency patient keeps the legacy modal chrome.
  const hasAgencyTreatmentChrome =
    immersiveModalStore.variant === 'agency-treatment' &&
    isAgencyRebrand(theme);

  return (
    <React.Fragment>
      {isAgencyRebrand(theme) && (
        // NOTE: `.modal-offclick-wrapper > div` is an internal radiance-ui DOM
        // class applied by ImmersiveModal. This global rule is intentionally
        // scoped to Agency + showModal, but it is coupled to radiance-ui's
        // markup structure and will break if that library renames the class or
        // changes the nesting. If ImmersiveModal ever exposes a borderRadius
        // prop, prefer that over this global override.
        <Global
          styles={css`
            .modal-offclick-wrapper > div {
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
            }
            ${MEDIA_QUERIES.mdUp} {
              .modal-offclick-wrapper > div {
                border-radius: 8px;
              }
            }
          `}
        />
      )}
      <ImmersiveModal
        css={hasAgencyTreatmentChrome ? Style.agencyTreatmentModal : undefined}
        onClose={immersiveModalStore.closeModal}
        footerContent={immersiveModalStore.footerContent}
        headerImage={immersiveModalStore.headerImage}
        title={immersiveModalStore.title}
      >
        {immersiveModalStore.modalContent}
      </ImmersiveModal>
    </React.Fragment>
  );
};
export default observer(ImmersiveModals);
